/* Verpakkingdeals: upsell-lade na toevoegen + aanbevelingen op productpagina. */
window.vdT = window.vdT || function (k, f, o) { if (o) for (var x in o) f = f.split('{' + x + '}').join(o[x]); return f; };
(function () {
  var FREE = 8000, POOL = '/collections/leuk-onder-10/products.json?limit=40';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var euro = function (c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { if (!src) return ''; return src.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_' + w + 'x$1$2'); }

  // Aanbevelingen op de productpagina inladen
  var rec = $('[data-vd-recs]');
  if (rec && rec.dataset.url) {
    fetch(rec.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var n = d.querySelector('[data-vd-recs]'); if (n && n.innerHTML.trim()) rec.innerHTML = n.innerHTML;
    }).catch(function () {});
  }


  // 18+: foto's pas tonen na leeftijdsbevestiging (zelfde cookie als de leeftijdscheck)
  var AGE = 'vd_leeftijd_18plus';
  function ageOk() { return document.cookie.split('; ').indexOf(AGE + '=ja') !== -1; }
  if (ageOk()) document.documentElement.classList.add('age-ok');
  document.addEventListener('click', function (e) {
    var v = e.target.closest('[data-age-veil]'); if (!v) return;
    e.preventDefault(); e.stopPropagation();
    var m = document.createElement('div'); m.className = 'age-modal'; m.setAttribute('role', 'dialog'); m.setAttribute('aria-modal', 'true');
    m.innerHTML = '<div class="age-box"><h2>' + vdT('age_title', 'Ben je 18 jaar of ouder?') + '</h2><p>' + vdT('age_text', 'Dit product is alleen voor volwassenen. We onthouden je keuze 30 dagen op dit apparaat.') + '</p><div class="btns"><button class="btn" data-a="ja">' + vdT('age_yes', 'Ja, ik ben 18+') + '</button><button class="btn-outline" data-a="nee">' + vdT('no', 'Nee') + '</button></div></div>';
    document.body.appendChild(m); m.querySelector('[data-a="ja"]').focus();
    m.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-a]'); if (!b && ev.target !== m) return;
      if (b && b.dataset.a === 'ja') { document.cookie = AGE + '=ja; Max-Age=' + (30 * 86400) + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); document.documentElement.classList.add('age-ok'); }
      m.remove();
    });
  }, true);

  // Upsell-lade
  var pool = null, el = null, last = null;
  function getPool() { return pool ? Promise.resolve(pool) : fetch(POOL).then(function (r) { return r.json(); }).then(function (j) { pool = (j.products || []).filter(function (p) { return p.variants && p.variants.some(function (v) { return v.available; }); }); return pool; }).catch(function () { return []; }); }
  function build() {
    el = document.createElement('div'); el.className = 'vdu'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'vdu-t');
    el.innerHTML = '<button class="vdu-scrim" aria-label="' + esc(vdT('close', 'Sluiten')) + '" data-vdu-close></button><div class="vdu-panel"><div class="vdu-head"><strong id="vdu-t">' + vdT('added_title', 'Toegevoegd!') + '</strong><button class="vdu-close" data-vdu-close aria-label="' + esc(vdT('close', 'Sluiten')) + '">✕</button></div><div class="vdu-body"></div><div class="vdu-foot"><a class="btn big" href="/cart">' + vdT('to_cart', 'Naar winkelwagen') + '</a><button class="vdu-cont" data-vdu-close>' + vdT('continue', 'Verder winkelen') + '</button></div></div>';
    document.body.appendChild(el);
    el.addEventListener('click', function (e) { if (e.target.closest('[data-vdu-close]')) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('on')) close(); });
  }
  function close() { el.classList.remove('on'); document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); }
  function open(variantId) {
    if (!el) build();
    last = document.activeElement;
    Promise.all([fetch('/cart.js').then(function (r) { return r.json(); }), getPool()]).then(function (res) {
      var cart = res[0], items = res[1], inCart = {};
      cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
      var added = cart.items.filter(function (i) { return String(i.variant_id) === String(variantId); })[0];
      var sub = cart.items_subtotal_price, need = FREE - sub, pct = Math.min(100, Math.round(sub / FREE * 100));
      var picks = items.filter(function (p) { return !inCart[p.id]; }).sort(function () { return Math.random() - .5; }).slice(0, 3);
      var h = '';
      if (added) h += '<div class="vdu-added"><img src="' + esc(img(added.image, 160)) + '" alt=""><div><b>' + esc(added.product_title) + '</b><span>' + euro(added.final_price) + '</span></div></div>';
      h += '<div class="vdu-ship">' + (need > 0 ? vdT('ship_need', 'Nog {amount} en je verzending is gratis', { amount: euro(need) }) : vdT('ship_free', 'Je verzending is gratis 🎉')) + '<div class="vdu-bar"><i style="width:' + pct + '%"></i></div></div>';
      if (picks.length) {
        h += '<h3>' + vdT('more', 'Nog iets leuks erbij?') + '</h3><div class="vdu-list">' + picks.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0], one = p.variants.length === 1;
          var im = p.images && p.images[0] ? img(p.images[0].src, 160) : '';
          return '<div class="vdu-item"><img src="' + esc(im) + '" alt="" loading="lazy"><div><a href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a><small>' + euro(Math.round(parseFloat(v.price) * 100)) + '</small></div>' +
            (one ? '<button class="add-btn" data-add="' + v.id + '" data-vdu-more aria-label="' + esc(vdT('add_title', '{title} toevoegen', { title: p.title })) + '">+</button>' : '<a class="btn-outline" href="/products/' + esc(p.handle) + '">' + vdT('choose', 'Kies') + '</a>') + '</div>';
        }).join('') + '</div>';
      }
      $('.vdu-body', el).innerHTML = h;
      el.classList.add('on'); document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { var c = $('.vdu-close', el); c && c.focus(); }, 50);
    });
  }
  // Elke geslaagde toevoeging (behalve gratis cadeaus) opent de lade.
  var lastBtn = null;
  document.addEventListener('click', function (e) { lastBtn = e.target.closest('button,a'); }, true);
  var of = window.fetch;
  window.fetch = function (u, o) {
    var p = of.apply(this, arguments);
    try {
      var url = typeof u === 'string' ? u : (u && u.url) || '';
      if (/\/cart\/add(\.js)?(\?|$)/.test(url) && o && o.body && String(o.body).indexOf('_gift') < 0) {
        var id = null; try { var b = JSON.parse(o.body); id = b.id || (b.items && b.items[0] && b.items[0].id); } catch (x) {}
        var btn = lastBtn;
        p.then(function (r) { if (r.ok) document.dispatchEvent(new CustomEvent('vd:added', { detail: { id: id, btn: btn } })); });
      }
    } catch (x) {}
    return p;
  };
  document.addEventListener('vd:added', function (e) {
    if (document.body.classList.contains('t-cart')) { location.reload(); return; }
    var more = e.detail && e.detail.btn && e.detail.btn.hasAttribute('data-vdu-more');
    if (more && el && el.classList.contains('on')) { setTimeout(function () { open(e.detail.id); }, 700); return; }
    open(e.detail && e.detail.id);
  });
  // Trustpilot-widget van bovenaan de pagina naar de footer verplaatsen
  (function mv(n) { var w = document.getElementById('trustpilot-widget-trustbox-0-wrapper'), f = document.querySelector('[data-ftr-trust], .ftr .grid4 > div');
    if (w && f) { f.appendChild(w); w.style.marginTop = '12px'; return; } if (n < 40) setTimeout(function () { mv(n + 1); }, 250); })(0);
})();
/* Mobiel: header inklappen bij naar beneden scrollen, sticky koopbalk pas tonen als de knop uit beeld is */
(function () {
  var y0 = window.scrollY, H = document.documentElement, tick = false;
  window.addEventListener('scroll', function () {
    if (tick) return; tick = true;
    requestAnimationFrame(function () {
      var y = window.scrollY;
      if (window.innerWidth <= 860) {
        if (y > 220 && y > y0 + 6) H.classList.add('hdr-up');
        else if (y < y0 - 6 || y < 120) H.classList.remove('hdr-up');
      } else H.classList.remove('hdr-up');
      y0 = y; tick = false;
    });
  }, { passive: true });
  var bars = document.querySelectorAll('[data-sticky-buy]'), main = document.querySelector('[data-add-main]');
  if (bars.length && main && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) { es.forEach(function (e) { var on = !e.isIntersecting && e.boundingClientRect.top < 0; bars.forEach(function (b) { b.classList.toggle('show', on); }); }); }).observe(main);
  } else bars.forEach(function (b) { b.classList.add('show'); });
})();
/* Hulpknop: vragen beantwoorden uit de winkelgegevens + producten zoeken */
(function () {
  var root = document.querySelector('[data-vdh]'), fab = document.querySelector('[data-vdh-fab]') || document.querySelector('[data-vdh-open]'), dataEl = document.querySelector('[data-vdh-data]');
  if (!root || !fab || !dataEl) return;
  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var q = root.querySelector('[data-vdh-q]'), home = root.querySelector('[data-vdh-home]'), res = root.querySelector('[data-vdh-results]'), clr = root.querySelector('[data-vdh-clear]'), body = root.querySelector('[data-vdh-body]');
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9+ ]+/g, ' '); };
  var euro = function (c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); };
  var lastFocus = null, cartLoaded = false;

  // Open/dicht: zijn we nu bereikbaar? (ma–vr 08:30–16:00 Nederlandse tijd)
  function openNow() {
    try {
      var p = new Intl.DateTimeFormat('nl-NL', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date()), o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      var m = parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10), wd = (o.weekday || '').toLowerCase();
      return !/^(za|zo)/.test(wd) && m >= 510 && m < 960;
    } catch (e) { return false; }
  }
  function link(l) {
    var t = l[0], u = l[1];
    if (u === 'ACCOUNT') u = D.account;
    else if (u === 'TEL') u = 'tel:' + D.teldig;
    else if (u.indexOf('MAIL:') === 0) u = 'mailto:' + D.mail + '?subject=' + encodeURIComponent(u.slice(5));
    var ext = /^https?:/.test(u) ? ' target="_blank" rel="noopener"' : '';
    return '<a class="vdh-l" href="' + esc(u) + '"' + ext + '>' + esc(t) + ' →</a>';
  }
  function topicHtml(t, open) {
    return '<details class="vdh-a"' + (open ? ' open' : '') + '><summary>' + esc(t.q) + '<span>+</span></summary><div>' + t.a + (t.links ? '<div class="vdh-ll">' + t.links.map(link).join('') + '</div>' : '') + '</div></details>';
  }
  function score(t, words) {
    var hay = norm(t.q + ' ' + t.k + ' ' + t.a.replace(/<[^>]+>/g, ' ')), s = 0;
    words.forEach(function (w) { if (w.length < 2) return; if (norm(t.k).indexOf(w) >= 0) s += 3; else if (hay.indexOf(w) >= 0) s += 1; });
    return s;
  }
  var prodT, prodSeq = 0;
  function products(term) {
    var seq = ++prodSeq, box = res.querySelector('[data-vdh-prod]');
    if (!box) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide').then(function (r) { return r.json(); }).then(function (j) {
      if (seq !== prodSeq) return;
      var list = (j.resources && j.resources.results && j.resources.results.products) || [];
      if (!list.length) { box.innerHTML = ''; return; }
      box.innerHTML = '<h3>' + vdT('products', 'Producten') + '</h3>' + list.map(function (p) {
        return '<a class="vdh-p" href="' + esc(p.url) + '">' + (p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy">' : '<span></span>') + '<span>' + esc(p.title) + '</span><b>' + esc(p.price ? '€ ' + String(p.price).replace('.', ',') : '') + '</b></a>';
      }).join('') + '<a class="vdh-l" href="/search?q=' + encodeURIComponent(term) + '">' + vdT('all_results', 'Alle resultaten voor ‘{term}’ →', { term: esc(term) }) + '</a>';
    }).catch(function () {});
  }
  function show(term) {
    term = (term || '').trim();
    clr.hidden = !term;
    if (!term) { home.hidden = false; res.hidden = true; res.innerHTML = ''; return; }
    var words = norm(term).split(' ').filter(Boolean);
    var hits = D.topics.map(function (t) { return { t: t, s: score(t, words) }; }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 4);
    var h = '';
    if (hits.length) h += '<h3>' + vdT('answers', 'Antwoorden') + '</h3>' + hits.map(function (x, i) { return topicHtml(x.t, i === 0); }).join('');
    else h += '<div class="vdh-note">' + vdT('no_answer', 'Hier hebben we nog geen kant-en-klaar antwoord op. Mail of bel ons, dan helpt een collega je verder.') + '</div><div class="vdh-ll">' + link([vdT('mail_q', 'Mail je vraag'), 'MAIL:' + term]) + link([vdT('call', 'Bel ons'), 'TEL']) + '</div>';
    h += '<div data-vdh-prod></div>';
    res.innerHTML = h; res.hidden = false; home.hidden = true; body.scrollTop = 0;
    clearTimeout(prodT); prodT = setTimeout(function () { products(term); }, 150);
  }
  function topic(id) {
    var t = D.topics.filter(function (x) { return x.id === id; })[0]; if (!t) return;
    q.value = ''; clr.hidden = true;
    res.innerHTML = topicHtml(t, true) + '<h3>' + vdT('also', 'Misschien ook handig') + '</h3>' + D.topics.filter(function (x) { return x.id !== id; }).slice(0, 4).map(function (x) { return topicHtml(x, false); }).join('') + '<button type="button" class="vdh-back" data-vdh-back>' + vdT('back', '← Terug naar overzicht') + '</button>';
    res.hidden = false; home.hidden = true; body.scrollTop = 0;
  }
  function cartNote() {
    if (cartLoaded) return; cartLoaded = true;
    var n = root.querySelector('[data-vdh-cart]'); if (!n) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.item_count) return;
      var need = 8000 - c.items_subtotal_price;
      n.innerHTML = '<b>🛒 ' + c.item_count + '</b><span>' + (need > 0 ? vdT('cart_need', 'nog {amount} tot gratis verzending', { amount: euro(need) }) : vdT('cart_free', 'gratis verzending 🎉')) + '</span>';
      n.hidden = false;
    }).catch(function () {});
  }
  function open() {
    lastFocus = document.activeElement; root.hidden = false; document.documentElement.classList.add('vdh-on');
    var st = root.querySelector('[data-vdh-open-state]'); if (st) st.innerHTML = openNow() ? '<i class="vdh-dot on"></i> ' + vdT('open_now', 'Nu bereikbaar: antwoord van een mens') : '<i class="vdh-dot"></i> ' + vdT('closed_now', 'Nu gesloten · werkdagen 08:30–16:00, mailen kan altijd');
    cartNote(); hideTease(true); setTimeout(function () { if (window.innerWidth > 860) q.focus(); }, 60);
  }
  function close() { root.hidden = true; document.documentElement.classList.remove('vdh-on'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
  fab.addEventListener('click', open);
  // Knop: online-status + teaser-bubbel (eenmalig, te sluiten)
  var fabState = document.querySelector('[data-vdh-fab-state]'), fabDot = document.querySelector('[data-vdh-dot]'), tease = document.querySelector('[data-vdh-tease]');
  if (fabState) fabState.textContent = openNow() ? vdT('online', 'Online') : vdT('leave_msg', 'Laat een bericht achter');
  if (fabDot) fabDot.classList.toggle('on', openNow());
  function hideTease(remember) { if (!tease) return; tease.hidden = true; if (remember) { try { sessionStorage.setItem('vd_tease', '1'); } catch (e) {} } }
  if (tease) {
    var seen = false; try { seen = !!sessionStorage.getItem('vd_tease'); } catch (e) {}
    if (!seen) setTimeout(function () { if (root.hidden && !document.querySelector('.age-modal,.vdu.on')) tease.hidden = false; }, 4500);
    tease.addEventListener('click', function (e) { if (e.target.closest('[data-vdh-tease-x]')) { e.stopPropagation(); hideTease(true); } else open(); });
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-vdh-close]')) return close();
    var tp = e.target.closest('[data-vdh-topic]'); if (tp) return topic(tp.getAttribute('data-vdh-topic'));
    if (e.target.closest('[data-vdh-back],[data-vdh-clear]')) { q.value = ''; show(''); q.focus(); return; }
    if (e.target.closest('[data-vdh-focus]')) { q.focus(); return; }
    if (e.target.closest('[data-vdh-go]')) { show(q.value); q.focus(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
  var t; q.addEventListener('input', function () { clearTimeout(t); t = setTimeout(function () { show(q.value); }, 120); });
  // Andere knoppen op de site mogen de hulp openen (bv. in de footer): data-vdh-open
  document.addEventListener('click', function (e) { var b = e.target.closest('[data-vdh-open]'); if (b && b !== fab) { e.preventDefault(); open(); } });
  // Hulpknop verbergen zolang de upsell-lade of leeftijdsvraag open is, gebeurt via CSS.
})();
/* Terug naar boven */
(function () {
  var b = document.querySelector('[data-top]'); if (!b) return;
  var on = false;
  window.addEventListener('scroll', function () { var s = window.scrollY > 900; if (s !== on) { on = s; b.classList.toggle('show', s); } }, { passive: true });
  b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
})();
/* Verlanglijst (op dit apparaat) */
(function () {
  var KEY = 'vd_wish';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function set(l) { try { localStorage.setItem(KEY, JSON.stringify(l.slice(0, 60))); } catch (e) {} }
  function paint() {
    var l = get(), ids = {}; l.forEach(function (x) { ids[x.h] = 1; });
    document.querySelectorAll('[data-wish]').forEach(function (b) { var on = !!ids[b.getAttribute('data-wish')]; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); if (b.hasAttribute('data-wish-text')) b.lastChild.textContent = on ? vdT('saved', 'Bewaard') : vdT('save', 'Bewaren'); });
    document.querySelectorAll('[data-wish-count]').forEach(function (c) { c.textContent = l.length; c.hidden = !l.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), l = get(), i = l.findIndex(function (x) { return x.h === h; });
    if (i >= 0) l.splice(i, 1); else l.unshift({ h: h, t: b.getAttribute('data-wish-title') || '', p: b.getAttribute('data-wish-price') || '', i: b.getAttribute('data-wish-img') || '' });
    set(l); paint();
    var t = document.getElementById('vd-toast'); if (t) { t.textContent = i >= 0 ? vdT('wish_removed', 'Uit je verlanglijst gehaald') : vdT('wish_added', 'Bewaard in je verlanglijst'); t.hidden = false; clearTimeout(t._t); t._t = setTimeout(function () { t.hidden = true; }, 2200); }
  });
  var page = document.querySelector('[data-wish-page]');
  if (page) {
    var l = get();
    page.innerHTML = l.length ? l.map(function (x) { return '<a class="quick-item" href="/products/' + encodeURIComponent(x.h) + '"><img src="' + x.i + '" alt=""><span>' + x.t.replace(/</g, '&lt;') + '</span><strong>' + x.p + '</strong></a>'; }).join('') : '<p class="muted">' + vdT('wish_empty', 'Je verlanglijst is nog leeg. Tik op het hartje bij een product om het te bewaren.') + '</p>';
  }
  paint();
})();
/* Productpagina: bestel vóór 14:00 op een werkdag = vandaag verzonden */
(function () {
  var el = document.querySelector('[data-ship-timer]'); if (!el) return;
  function upd() {
    try {
      var p = new Intl.DateTimeFormat('nl-NL', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false }).formatToParts(new Date()), o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      var m = parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10), wd = (o.weekday || '').toLowerCase(), left = 14 * 60 - m;
      if (!/^(za|zo)/.test(wd) && left > 0) { var h = Math.floor(left / 60), mm = left % 60; el.innerHTML = '🚚 ' + vdT('timer', 'Bestel binnen <b>{time}</b>, dan gaat je pakket vandaag nog mee', { time: (h ? vdT('timer_h', '{h} uur', { h: h }) + ' ' : '') + vdT('timer_m', '{m} min', { m: mm }) }); }
      else el.innerHTML = '🚚 ' + vdT('timer_next', 'Bestel nu, dan gaat je pakket op de eerstvolgende werkdag mee');
    } catch (e) { el.hidden = true; }
  }
  upd(); setInterval(upd, 30000);
})();
/* Vaak samen gekocht: totaal en in één keer toevoegen */
(function () {
  var box = document.querySelector('[data-fbt]'); if (!box) return;
  var euro = function (c) { return '€ ' + (c / 100).toFixed(2).replace('.', ','); };
  function mainPrice() { var h = document.querySelector('[data-variant-id]'), P = window.VD_PRODUCT; if (h && P) { var v = P.variants.filter(function (x) { return String(x.id) === String(h.value); })[0]; if (v) return v.price; } return +box.getAttribute('data-main-price') || 0; }
  function total() {
    var t = mainPrice(), n = 1;
    box.querySelectorAll('[data-fbt-item]:checked').forEach(function (i) { t += +i.getAttribute('data-price'); n++; });
    box.querySelector('[data-fbt-total]').textContent = euro(t);
    var mp = box.querySelector('[data-fbt-main-price]'); if (mp) mp.textContent = euro(mainPrice());
    var b = box.querySelector('[data-fbt-add]'); b.textContent = n > 1 ? vdT('add_n', 'Voeg {n} producten toe', { n: n }) : vdT('add_to_cart', 'In winkelwagen');
  }
  box.addEventListener('change', total); document.addEventListener('change', function (e) { if (e.target.closest('[data-product-form]')) setTimeout(total, 30); }); total();
  box.querySelector('[data-fbt-add]').addEventListener('click', function () {
    var h = document.querySelector('[data-variant-id]'), items = [];
    if (h && h.value) items.push({ id: +h.value, quantity: 1 });
    box.querySelectorAll('[data-fbt-item]:checked').forEach(function (i) { items.push({ id: +i.getAttribute('data-vid'), quantity: 1 }); });
    if (!items.length) return;
    var b = box.querySelector('[data-fbt-add]'), t = b.textContent; b.disabled = true; b.textContent = vdT('busy', 'Bezig…');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'mislukt'); fetch('/cart.js').then(function (x) { return x.json(); }).then(function (c) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; }); }); }); })
      .catch(function (e) { var tt = document.getElementById('vd-toast'); if (tt) { tt.textContent = e.message; tt.hidden = false; setTimeout(function () { tt.hidden = true; }, 2600); } })
      .then(function () { b.disabled = false; b.textContent = t; });
  });
})();
